import React from 'react';
import { useTranslation } from 'react-i18next';
import Hamburger from '../../common/hamburger';
import logo from './header-logo.png';
import logo2x from './header-logo@2x.png';
import css from './index.module.css';
import { ABOUT, HELP, INFOPAGE } from '../../../router/routes';

export default function Header() {
  const { t } = useTranslation();

  return (
    <header className={css['header']}>
      <div className={css['content']}>
        <a href={INFOPAGE} className={css['logo']}>
          <img
            src={logo}
            srcSet={logo + ' 1x,' + logo2x + ' 2x'}
            alt=""
            className="logo"
          />
        </a>

        <ul className={css['menu']}>
          <li className={css['menu-item']}>
            <a href={INFOPAGE}>{t('components.external.header.home')}</a>
          </li>
          <li className={css['menu-item']}>
            <a href={ABOUT}>{t('components.external.header.about')}</a>
          </li>
          <li className={css['menu-item']}>
            <a href={HELP}>{t('components.external.header.help')}</a>
          </li>
        </ul>

        <div className={css['hamburger-wrapper']}>
          <Hamburger />
        </div>
      </div>
    </header>
  );
}
